export enum Difficulty {
    Easy = 0,
    Normal = 1,
    Hard = 2,
    Extreme = 3,
}
